import React, { useEffect, useState } from "react";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  IconButton,
  Box,
} from "@mui/material";
import { marked } from "marked";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import { Fade } from "react-awesome-reveal";
import {
  IHeaderFooterData,
  IPaymentData,
  ITermsConditionsData,
} from "../../exports/interfaces";
import { dynamicFailed, dynamicSuccess } from "../../hooks/useToast";
import { submitMessage } from "../../api/TermsConditionApi";
import { useLoader } from "../../context/LoaderContext";
import { useCompanyDetailsContext } from "../../context/CompanyDetailsContext";

const TermsDetails = (props: {
  headerFooterData: IHeaderFooterData[];
  termsConditionsData: ITermsConditionsData[];
}) => {
  const { companyDetailsData } = useCompanyDetailsContext();

  const [paymentData, setPaymentData] = useState<IPaymentData[]>([]);
  const [expandedPaymant, setExpandedPayment] = useState<string | false>(false);
  const [isChecked, setIsChecked] = useState(false);
  const [formData, setFormData] = useState({
    Name: "",
    Email: "",
    Phone: "",
    Message: "",
  });
  const { setLoading } = useLoader();

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
  ) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleCheckboxChange = () => {
    setIsChecked(!isChecked);
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!isChecked) {
      dynamicFailed("You must consent before submitting!");
      return;
    }

    try {
      setLoading(true);
      const message = {
        name: formData.Name,
        email: formData.Email,
        phone: formData.Phone,
        message: formData.Message,
      };

      const response = await submitMessage(message);

      if (response?.status === 200 || response?.status === 201) {
        dynamicSuccess("Message sent successfully!");
        setFormData({ Name: "", Email: "", Phone: "", Message: "" });
        setIsChecked(false);
        setLoading(false);
      } else {
        setLoading(false);
        dynamicFailed("Could not send message! Please try again later.");
      }
    } catch (error: any) {
      setLoading(false);
      dynamicFailed(error.response.data.error.message);
    }
  };

  useEffect(() => {
    const processMarkdown = async () => {
      const data = await Promise.all(
        props.termsConditionsData.map(async (data) => ({
          id: `panel${data?.id}`,
          title: data?.title,
          description: await marked(data?.description || ""),
        })),
      );
      setPaymentData(data);
    };

    processMarkdown();
  }, [props.termsConditionsData]);

  useEffect(() => {
    if (paymentData.length > 0) {
      setExpandedPayment(paymentData[paymentData.length - 1].id);
    }
  }, [paymentData]);

  const handlePaymentChange =
    (panel: string) => (_: React.SyntheticEvent, isExpanded: boolean) => {
      setExpandedPayment(isExpanded ? panel : false);
    };
  // const [expandedReservation, setExpandedReservation] = useState<
  //   string | false
  // >(ReservationData[ReservationData.length - 1].id);

  // const handleReservationChange =
  //   (panel: string) => (_: React.SyntheticEvent, isExpanded: boolean) => {
  //     setExpandedReservation(isExpanded ? panel : false);
  //   };
  return (
    <>
      <Fade direction="down" triggerOnce={true}>
        <div
          id="page_content_wrapper"
          className="noheader"
          style={{ padding: "unset" }}
        >
          <div className="inner">
            {/* <!-- Begin main content --> */}
            <div className="inner_wrapper">
              <div
                className="sidebar_content full_width nopadding custom-row-element"
                style={{ display: "flex", justifyContent: "space-evenly" }}
              >
                <div
                  className="sidebar_content page_content custom-terms-page_content"
                  style={{ width: "55dvw", marginTop: "unset" }}
                >
                  <div
                    data-elementor-type="wp-post"
                    data-elementor-id="770"
                    className="elementor elementor-770"
                    data-elementor-settings="[]"
                  >
                    <div className="elementor-inner">
                      <div className="elementor-section-wrap">
                        <section
                          className="elementor-section elementor-top-section elementor-element elementor-element-c8d681f elementor-section-boxed elementor-section-height-default elementor-section-height-default"
                          data-id="c8d681f"
                          data-element_type="section"
                          data-settings='{"hoteller_ext_is_background_parallax":"false","hoteller_ext_is_background_on_scroll":"false"}'
                        >
                          <div className="elementor-container elementor-column-gap-default">
                            <div className="elementor-row">
                              <div
                                className="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-03a5609"
                                data-id="03a5609"
                                data-element_type="column"
                                data-settings='{"hoteller_ext_is_scrollme":"false","hoteller_ext_is_smoove":"false","hoteller_ext_is_parallax_mouse":"false","hoteller_ext_is_infinite":"false","hoteller_ext_is_fadeout_animation":"false"}'
                              >
                                <div className="elementor-column-wrap elementor-element-populated">
                                  <div className="elementor-widget-wrap">
                                    <div
                                      className="elementor-element elementor-element-1a8b0ed elementor-widget elementor-widget-heading"
                                      data-id="1a8b0ed"
                                      data-element_type="widget"
                                      data-settings='{"hoteller_ext_is_scrollme":"false","hoteller_ext_is_smoove":"false","hoteller_ext_is_parallax_mouse":"false","hoteller_ext_is_infinite":"false","hoteller_ext_is_fadeout_animation":"false"}'
                                      data-widget_type="heading.default"
                                    >
                                      <div className="elementor-widget-container">
                                        <h2 className="widgettitle">
                                          <span>Terms and Conditions</span>
                                        </h2>
                                        <p
                                          className="elementor-heading-title elementor-size-default"
                                          dangerouslySetInnerHTML={{
                                            __html:
                                              props?.headerFooterData[0]
                                                ?.header,
                                          }}
                                        />
                                      </div>
                                    </div>
                                    <div
                                      className="elementor-element elementor-element-625b11b elementor-widget elementor-widget-accordion"
                                      data-id="625b11b"
                                      data-element_type="widget"
                                      data-settings='{"hoteller_ext_is_scrollme":"false","hoteller_ext_is_smoove":"false","hoteller_ext_is_parallax_mouse":"false","hoteller_ext_is_infinite":"false","hoteller_ext_is_fadeout_animation":"false"}'
                                      data-widget_type="accordion.default"
                                    >
                                      <div className="elementor-widget-container">
                                        <div
                                          className="elementor-accordion"
                                          role="tablist"
                                        >
                                          <div className="elementor-accordion-item">
                                            {paymentData.map((item) => (
                                              <Accordion
                                                key={item.id}
                                                expanded={
                                                  expandedPaymant === item.id
                                                }
                                                onChange={handlePaymentChange(
                                                  item.id,
                                                )}
                                              >
                                                <AccordionSummary
                                                  expandIcon={
                                                    <ExpandMoreIcon />
                                                  }
                                                  aria-controls={`${item.id}-content`}
                                                  id={`${item.id}-header`}
                                                >
                                                  <Box
                                                    sx={{
                                                      display: "flex",
                                                      alignItems: "center",
                                                    }}
                                                  >
                                                    <IconButton edge="start">
                                                      {expandedPaymant ===
                                                      item.id ? (
                                                        <RemoveIcon />
                                                      ) : (
                                                        <AddIcon />
                                                      )}
                                                    </IconButton>
                                                    <div
                                                      id="elementor-tab-title-1031"
                                                      className="elementor-tab-title"
                                                      data-tab="1"
                                                      role="tab"
                                                      aria-controls="elementor-tab-content-1031"
                                                    >
                                                      <span
                                                        className="elementor-accordion-icon elementor-accordion-icon-left"
                                                        aria-hidden="true"
                                                      >
                                                        <i className="elementor-accordion-icon-closed fa fa-plus-square-o"></i>
                                                        <i className="elementor-accordion-icon-opened fa fa-minus-square-o"></i>
                                                      </span>
                                                      {/* <a
                                                      className="elementor-accordion-title"
                                                      href="/"
                                                    > */}
                                                      <strong>
                                                        {item.title}
                                                      </strong>
                                                      {/* </a> */}
                                                    </div>
                                                  </Box>
                                                </AccordionSummary>
                                                <AccordionDetails>
                                                  <div
                                                    id="elementor-tab-content-1031"
                                                    className="elementor-tab-content elementor-clearfix"
                                                    data-tab="1"
                                                    role="tabpanel"
                                                    aria-labelledby="elementor-tab-title-1031"
                                                    style={{
                                                      padding: "0px 16px",
                                                    }}
                                                  >
                                                    <p>
                                                      <div
                                                        dangerouslySetInnerHTML={{
                                                          __html:
                                                            item.description,
                                                        }}
                                                      />
                                                    </p>
                                                  </div>
                                                </AccordionDetails>
                                              </Accordion>
                                            ))}
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    <div
                                      className="elementor-element elementor-element-1a8b0ed elementor-widget elementor-widget-heading"
                                      data-id="1a8b0ed"
                                      data-element_type="widget"
                                      data-settings='{"hoteller_ext_is_scrollme":"false","hoteller_ext_is_smoove":"false","hoteller_ext_is_parallax_mouse":"false","hoteller_ext_is_infinite":"false","hoteller_ext_is_fadeout_animation":"false"}'
                                      data-widget_type="heading.default"
                                    >
                                      <div className="elementor-widget-container">
                                        <p
                                          className="elementor-heading-title elementor-size-default"
                                          dangerouslySetInnerHTML={{
                                            __html:
                                              props?.headerFooterData[0]
                                                ?.footer,
                                          }}
                                        />
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </section>
                        {/* <section
                        className="elementor-section elementor-top-section elementor-element elementor-element-b9b2d6f elementor-section-boxed elementor-section-height-default elementor-section-height-default"
                        data-id="b9b2d6f"
                        data-element_type="section"
                        data-settings='{"hoteller_ext_is_background_parallax":"false","hoteller_ext_is_background_on_scroll":"false"}'
                      >
                        <div className="elementor-container elementor-column-gap-default">
                          <div className="elementor-row">
                            <div
                              className="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-559ab3b"
                              data-id="559ab3b"
                              data-element_type="column"
                              data-settings='{"hoteller_ext_is_scrollme":"false","hoteller_ext_is_smoove":"false","hoteller_ext_is_parallax_mouse":"false","hoteller_ext_is_infinite":"false","hoteller_ext_is_fadeout_animation":"false"}'
                            >
                              <div className="elementor-column-wrap elementor-element-populated">
                                <div className="elementor-widget-wrap">
                                  <div
                                    className="elementor-element elementor-element-af5a57e elementor-widget elementor-widget-heading"
                                    data-id="af5a57e"
                                    data-element_type="widget"
                                    data-settings='{"hoteller_ext_is_scrollme":"false","hoteller_ext_is_smoove":"false","hoteller_ext_is_parallax_mouse":"false","hoteller_ext_is_infinite":"false","hoteller_ext_is_fadeout_animation":"false"}'
                                    data-widget_type="heading.default"
                                  >
                                    <div className="elementor-widget-container">
                                      <h3 className="elementor-heading-title elementor-size-default custom-terms-h3">
                                        Reservation
                                      </h3>
                                    </div>
                                  </div>
                                  <div
                                    className="elementor-element elementor-element-58f1580 elementor-widget elementor-widget-accordion"
                                    data-id="58f1580"
                                    data-element_type="widget"
                                    data-settings='{"hoteller_ext_is_scrollme":"false","hoteller_ext_is_smoove":"false","hoteller_ext_is_parallax_mouse":"false","hoteller_ext_is_infinite":"false","hoteller_ext_is_fadeout_animation":"false"}'
                                    data-widget_type="accordion.default"
                                  >
                                    <div className="elementor-widget-container">
                                      <div
                                        className="elementor-accordion"
                                        role="tablist"
                                      >
                                        <div className="elementor-accordion-item">
                                          {ReservationData.map((item) => (
                                            <Accordion
                                              key={item.id}
                                              expanded={
                                                expandedReservation === item.id
                                              }
                                              onChange={handleReservationChange(
                                                item.id
                                              )}
                                            >
                                              <AccordionSummary
                                                expandIcon={<ExpandMoreIcon />}
                                                aria-controls={`${item.id}-content`}
                                                id={`${item.id}-header`}
                                              >
                                                <Box
                                                  sx={{
                                                    display: "flex",
                                                    alignItems: "center",
                                                  }}
                                                >
                                                  <IconButton edge="start">
                                                    {expandedReservation ===
                                                    item.id ? (
                                                      <RemoveIcon />
                                                    ) : (
                                                      <AddIcon />
                                                    )}
                                                  </IconButton>
                                                  <div
                                                    id="elementor-tab-title-1031"
                                                    className="elementor-tab-title"
                                                    data-tab="1"
                                                    role="tab"
                                                    aria-controls="elementor-tab-content-1031"
                                                  >
                                                    <span
                                                      className="elementor-accordion-icon elementor-accordion-icon-left"
                                                      aria-hidden="true"
                                                    >
                                                      <i className="elementor-accordion-icon-closed fa fa-plus-square-o"></i>
                                                      <i className="elementor-accordion-icon-opened fa fa-minus-square-o"></i>
                                                    </span>
                                                      <strong>
                                                        {item.title}
                                                      </strong>
                                                  </div>
                                                </Box>
                                              </AccordionSummary>
                                              <AccordionDetails>
                                                <div
                                                  id="elementor-tab-content-1031"
                                                  className="elementor-tab-content elementor-clearfix"
                                                  data-tab="1"
                                                  role="tabpanel"
                                                  aria-labelledby="elementor-tab-title-1031"
                                                >
                                                  <p>{item.description}</p>
                                                </div>
                                              </AccordionDetails>
                                            </Accordion>
                                          ))}
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </section> */}
                      </div>
                    </div>
                  </div>
                </div>

                <div className="sidebar_wrapper">
                  <div className="sidebar">
                    <div className="content">
                      <ul className="sidebar_widget">
                        <li
                          id="text-11"
                          className="widget widget_text custom-terms-page_content"
                        >
                          <h2 className="widgettitle">
                            <span>Can&#8217;t Find Answer? Ask us</span>
                          </h2>
                          <div className="textwidget">
                            <div
                              role="form"
                              className="wpcf7"
                              id="wpcf7-f5-o1"
                              lang="en-US"
                              dir="ltr"
                            >
                              <div
                                className="screen-reader-response"
                                role="alert"
                                aria-live="polite"
                              ></div>
                              <form
                                onSubmit={handleSubmit}
                                className="wpcf7-form init"
                              >
                                <p>
                                  <label>
                                    Name (*)
                                    <br />
                                    <span className="wpcf7-form-control-wrap your-name">
                                      <input
                                        type="text"
                                        name="Name"
                                        value={formData.Name}
                                        onChange={handleChange}
                                        required
                                        className="wpcf7-form-control wpcf7-text wpcf7-validates-as-required"
                                        aria-required="true"
                                        aria-invalid="false"
                                      />
                                    </span>
                                  </label>
                                </p>
                                <p>
                                  <label>
                                    Email (*)
                                    <br />
                                    <span className="wpcf7-form-control-wrap your-email">
                                      <input
                                        type="email"
                                        name="Email"
                                        value={formData.Email}
                                        onChange={handleChange}
                                        required
                                        className="wpcf7-form-control wpcf7-text wpcf7-email wpcf7-validates-as-required wpcf7-validates-as-email"
                                        aria-required="true"
                                        aria-invalid="false"
                                      />
                                    </span>
                                  </label>
                                </p>
                                <p>
                                  <label>
                                    Phone
                                    <br />
                                    <span className="wpcf7-form-control-wrap phone">
                                      <input
                                        type="text"
                                        name="Phone"
                                        value={formData.Phone}
                                        onChange={handleChange}
                                        className="wpcf7-form-control wpcf7-text"
                                        aria-invalid="false"
                                      />
                                    </span>
                                  </label>
                                </p>
                                <p>
                                  <label>
                                    Your Message
                                    <br />
                                    <span className="wpcf7-form-control-wrap your-message">
                                      <textarea
                                        name="Message"
                                        value={formData.Message}
                                        onChange={handleChange}
                                        required
                                        className="wpcf7-form-control wpcf7-textarea"
                                        aria-invalid="false"
                                      ></textarea>
                                    </span>
                                  </label>
                                </p>
                                <p>
                                  <span className="wpcf7-form-control-wrap gdpr">
                                    <span className="wpcf7-form-control wpcf7-checkbox wpcf7-validates-as-required">
                                      <span className="wpcf7-list-item first last">
                                        <input
                                          type="checkbox"
                                          name="gdpr[]"
                                          checked={isChecked}
                                          onChange={handleCheckboxChange}
                                          value="I consent to Hoteller Luxury Hotel collecting my details through this form."
                                          disabled
                                        />
                                        <span className="wpcf7-list-item-label">
                                          I consent to{" "}
                                          {companyDetailsData[0]?.company_name}{" "}
                                          collecting my details through this
                                          form.
                                        </span>
                                      </span>
                                    </span>
                                  </span>
                                </p>
                                <p>
                                  <input
                                    type="submit"
                                    value="Send"
                                    className="wpcf7-form-control wpcf7-submit"
                                    disabled
                                  />
                                </p>
                                <div
                                  className="wpcf7-response-output"
                                  role="alert"
                                  aria-hidden="true"
                                ></div>
                              </form>
                            </div>
                          </div>
                        </li>
                      </ul>
                    </div>
                  </div>
                  <br className="clear" />
                </div>
              </div>
            </div>
            {/* <!-- End main content --> */}
          </div>
          <br className="clear" />
        </div>
      </Fade>
    </>
  );
};

export default TermsDetails;
